import { useState, useEffect, createContext, useContext } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContentContext = createContext({});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/content`)
      .then(res => {
        setContent(res.data);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  const refresh = async () => {
    try {
      const res = await axios.get(`${API}/content`);
      setContent(res.data);
    } catch (e) { /* ignore */ }
  };

  return (
    <ContentContext.Provider value={{ content, loaded, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
